import { render, staticRenderFns } from "./TitleBox.html?vue&type=template&id=2fc24e37&scoped=true&"
import script from "./TitleBox.js?vue&type=script&lang=js&"
export * from "./TitleBox.js?vue&type=script&lang=js&"
import style0 from "./TitleBox.scss?vue&type=style&index=0&id=2fc24e37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc24e37",
  null
  
)

export default component.exports